export const API_URL = process.env.REACT_APP_API || "http://localhost:9000";
export const CONF = process.env.REACT_APP_CONF || "fnp";
export const SESSIONS = process.env.REACT_APP_SESSIONS || "1,2,3,4,5,6,7,8,9";
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "http://localhost:9002";
